export interface CallInCadenceRow {
  sensorId: string;
  /** Customer-facing device identifier (sensor.device_id). Nullable in the
   * schema, so consumers must handle missing values. */
  deviceId: string | null;
  propertyName: string | null;
  meterType: string | null;
  /** Mean days between consecutive successful call-ins. Null when callInCount < 2. */
  avgGapDays: number | null;
  callInCount: number;
  /** ISO bare string in meter local time, or null when no call-ins in window. */
  firstCallInAt: string | null;
  /** ISO bare string in meter local time, or null when no call-ins in window. */
  lastCallInAt: string | null;
}

/** Allowed window sizes for the call-in cadence report. Cost scales linearly
 * with chunks scanned in the underlying hypertable, so smaller windows are
 * substantially faster. Default is the smallest of these. */
export const CALL_IN_CADENCE_WINDOW_DAYS = [30, 60, 90] as const;
export type CallInCadenceWindowDays = typeof CALL_IN_CADENCE_WINDOW_DAYS[number];
export const DEFAULT_CALL_IN_CADENCE_WINDOW_DAYS: CallInCadenceWindowDays = 30;

export interface CallInCadenceReportResponse {
  rows: CallInCadenceRow[];
  /** ISO timestamp (UTC) of the inclusive window start. */
  windowStart: string;
  /** ISO timestamp (UTC) of the inclusive window end. */
  windowEnd: string;
  /** Window size used for this report, in days. */
  windowDays: CallInCadenceWindowDays;
}
